import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { PurchaseNavButton } from './CheckoutFlow';
import analytics from '../lib/analytics';

/** From Soro dashboard → Connect Your Website */
const SORO_EMBED_SRC =
  'https://app.trysoro.com/api/embed/b79b71f8-f1ac-46d7-99c3-2dcbe8f44957';

function BlogNav() {
  return (
    <nav className="bg-[#3A3A3F] px-4 sm:px-6 py-4">
      <div className="max-w-4xl mx-auto flex items-center justify-between gap-3">
        <a href="/" className="flex items-center text-white hover:opacity-90 min-w-0">
          <span className="wordmark-mark" aria-hidden="true"></span>
          <span className="wordmark text-lg text-white truncate">ImmigrateSmart</span>
        </a>
        <div className="flex items-center gap-3 sm:gap-4 shrink-0">
          <Link to="/blog" className="text-[#D4A017] text-sm font-medium hidden sm:inline">
            Blog
          </Link>
          <PurchaseNavButton />
          <a href="/eligibility" className="text-white/80 hover:text-[#D4A017] text-sm">
            Eligibility
          </a>
        </div>
      </div>
    </nav>
  );
}

function useSoroEmbed() {
  useEffect(() => {
    analytics.trackPageView('blog');
    document.title = 'Blog · ImmigrateSmart';

    let script = document.querySelector(`script[data-soro-embed="1"]`);
    if (!script) {
      script = document.createElement('script');
      script.src = SORO_EMBED_SRC;
      script.defer = true;
      script.dataset.soroEmbed = '1';
      document.body.appendChild(script);
    }

    // If the script was already loaded (SPA remount), ask it to re-bind if it exposes a hook.
    const tryMount = () => {
      if (typeof window !== 'undefined' && typeof window.Soro?.mount === 'function') {
        window.Soro.mount('#soro-blog');
      }
    };
    script.addEventListener('load', tryMount);
    tryMount();

    return () => {
      script.removeEventListener('load', tryMount);
    };
  }, []);
}

/** /blog — Soro embed widget (Connect Your Website snippet) */
export default function BlogPage() {
  useSoroEmbed();

  return (
    <div className="min-h-screen bg-[#F4F3F0]">
      <BlogNav />
      <main className="max-w-4xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <p className="text-[10px] tracking-[0.16em] uppercase text-[#B8860B] font-semibold mb-2">
          Guides &amp; updates
        </p>
        <h1 className="font-cormorant text-4xl sm:text-5xl text-[#222226] mb-3">Blog</h1>
        <p className="text-[#3F3C38] text-sm leading-relaxed mb-8 max-w-xl">
          Immigration pathway explainers and product updates. Informational only — not legal advice.
        </p>

        {/* Soro Connect Your Website embed target */}
        <div id="soro-blog" />

        <p className="mt-12 text-xs text-[#3F3C38]/60 leading-relaxed">
          ImmigrateSmart provides legal information and document-preparation tools, not legal advice.{' '}
          <Link to="/legal/disclaimer" className="text-[#B8860B] hover:underline">
            Full disclaimer
          </Link>
        </p>
      </main>
    </div>
  );
}
